import * as ReactDOM from "react-dom/client";
import AppRouter from "./routes/Router";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline, GlobalStyles } from "@mui/material";
import { Theme } from "./theme";

function App() {

  return (
    <ThemeProvider theme={Theme}>
      <CssBaseline />
      <GlobalStyles
        styles={{
          "html, body, #root": {
            margin: 0,
            padding: 0,
            width: "100vw",
            overflowX: "hidden",
            backgroundColor: Theme.palette.background.default,
            color: Theme.palette.text.primary,
            fontSize: "16px",
          },
        }}
      />
      <AppRouter />
    </ThemeProvider>
  );
}
// Trigger redeploy - remove nginx config, rout reload (checklist, sighn-in)
ReactDOM.createRoot(document.getElementById("root")!).render(<App />);
